import moment from 'moment';
import { connect } from 'react-redux';

import * as routingSelectors from '../../../../selectors/routingSelectors';
import * as userSelectors from '../../../../selectors/user/userSelectors';
import { getDaysTillWeddingDate } from '../helpers';

import ChecklistHeader from './ChecklistHeader';

const mapStateToProps = (state) => {
  const now = moment();
  const weddingDate = userSelectors.getUserWeddingDate(state);
  const daysTillWedding = getDaysTillWeddingDate(now, weddingDate);
  const routingState = routingSelectors.getRoutingState(state) || {};
  const isFirstTimeChecklistUser = routingState.isFirstTimeChecklistUser || false;

  return {
    daysTillWedding,
    firstName: userSelectors.getOwnerFirstName(state),
    partnerFirstName: userSelectors.getPartnerFirstName(state),
    isFirstTimeChecklistUser,
  };
};

export default connect(mapStateToProps)(ChecklistHeader);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistHeader/index.js